import {

  afterNextRender, ChangeDetectionStrategy, Component, computed, DestroyRef, ElementRef, inject, signal, viewChild
} from '@angular/core';

import { SignageRuntimeService } from '../../runtime/signage-runtime.service';

@Component({
  selector: 'ds-priority-banner',
  templateUrl: './priority-banner.component.html',
  styleUrls: ['./priority-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PriorityBannerComponent {
  private readonly runtime = inject(SignageRuntimeService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly container = viewChild<ElementRef<HTMLElement>>('container');
  private readonly list = viewChild<ElementRef<HTMLElement>>('list');
  private readonly overflowing = signal(false);

  public readonly messages = computed(() => this.runtime.priorityMessages()
    .map(item => ({ id: item.id, subject: item.subject, text: item.bodyContent?.text ?? '' })));
  // A list wider than the screen scrolls, and a clone keeps the marquee seamless.
  public readonly scrolling = computed(() => this.overflowing());
  public readonly single = computed(() => !this.overflowing() && this.messages().length <= 1);
  public readonly still = computed(() => !this.overflowing() && this.messages().length > 1);

  public constructor() {
    afterNextRender(() => {
      const observer = new ResizeObserver(() => this.measure());
      observer.observe(this.container().nativeElement);
      observer.observe(this.list().nativeElement);
      this.measure();
      this.destroyRef.onDestroy(() => observer.disconnect());
    });
  }

  private measure(): void {
    const container = this.container()?.nativeElement;
    const list = this.list()?.nativeElement;
    this.overflowing.set(!!container && !!list && list.scrollWidth > container.offsetWidth);
  }
}
